/** F606 Trainees page — bridge-backed listing of active trainees. */
import { User as UserIcon } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606TraineesPage() {
  return (
    <F606DataPage
      entity="trainees"
      titleAr="المتدربون"
      titleEn="Trainees"
      icon={UserIcon}
      emptyIcon={UserIcon}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'name',
          ar: 'المتدرّب', en: 'Trainee',
          render: (r) => {
            const p = r.trainee_profile || {};
            return (
              <div>
                <div className="font-bold text-white">{r.full_name || r.name || '—'}</div>
                {p.membership_number && (
                  <div className="text-[10px] font-mono text-white/40" dir="ltr">{p.membership_number}</div>
                )}
              </div>
            );
          },
        },
        {
          key: 'goal',
          ar: 'الهدف', en: 'Goal',
          render: (r) => {
            const goal = r.trainee_profile?.goal;
            if (!goal) return '—';
            // Prettify snake_case goals
            return <span className="text-[11px] text-white/70">{String(goal).replace(/_/g, ' ')}</span>;
          },
          className: 'w-32',
        },
        {
          key: 'fitness_level',
          ar: 'المستوى', en: 'Level',
          render: (r) => {
            const lvl = r.trainee_profile?.fitness_level;
            return lvl ? <span className="text-[11px] capitalize text-cyan-300">{lvl}</span> : '—';
          },
          className: 'w-24',
        },
        {
          key: 'subscriptions_count',
          ar: 'الاشتراكات', en: 'Subs',
          render: (r) => r.subscriptions_count ?? '—',
          className: 'w-20 text-center',
        },
        {
          key: 'joined_at',
          ar: 'انضم في', en: 'Joined',
          render: (r) => {
            const d = r.trainee_profile?.created_at || r.joined_at || r.created_at;
            return d ? new Date(d).toLocaleDateString() : '—';
          },
          className: 'w-28 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
